import { render, staticRenderFns } from "./SelectPosition.vue?vue&type=template&id=a2da084a&scoped=true&"
import script from "./SelectPosition.vue?vue&type=script&lang=js&"
export * from "./SelectPosition.vue?vue&type=script&lang=js&"
import style0 from "./SelectPosition.vue?vue&type=style&index=0&id=a2da084a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2da084a",
  null
  
)

export default component.exports